<template>
  <component
    :is="homeComponent"
    @signin="$emit('signin')"
    v-bind="$attrs"
  ></component>
</template>

<script>
export default {
  name: "home",
  inheritAttrs: false,
  props: ["isSignedIn"],
  computed: {
    homeComponent() {
      return this.isSignedIn
        ? () => import("./DashBoard")
        : () => import("./SignIn");
    }
  }
};
</script>
